import { FormControl, FormGroup, ValidationErrors } from '@angular/forms';
import { FormError } from '../models/form-error.model';


export function getSearchFormErrorMessage(form: FormGroup): string {
  return Object.keys(form.errors ?? {}).reduce(
    (message, key) => (message += mapSearchFormErrorMessage(key) + '\n'),
    ''
  );
}

export function getFormErrors(form: FormGroup): FormError[] {
  return Object.keys(form.controls)
    .filter(key => form.get(key)?.errors)
    .map(key => ({ controlName: key, errors: Object.keys(form.get(key)!.errors!) }));
}

export function getValidationErrors(form: FormGroup): ValidationErrors {
  const controlsErrors = Object.keys(form.controls)
    .filter(key => form.get(key)?.errors)
    .reduce((map: any, key) => ((map[key] = form.get(key)!.errors!), map), {});

  return Object.assign({}, controlsErrors, form.errors);
}

export function getFormControl(form: FormGroup, name: string): FormControl | null {
  return form.contains(name) ? (form.get(name) as FormControl) : null;
}

export function updateValueAndValidity(form: FormGroup): void {
  Object.values(form.controls).forEach(control => control.updateValueAndValidity());
}

function mapSearchFormErrorMessage(key: string): string {
  switch (key) {
    case 'emptyForm':
      return 'No search criteria entered. Cannot continue.';
    case 'offenceFromRequired':
      return 'Offense From Date Required.';
    case 'offenceToRequired':
      return 'Offense To Date Required.';
    default:
      return 'Error';
  }
}
